import { render, staticRenderFns } from "./fankui.vue?vue&type=template&id=8c52b1ee&scoped=true"
import script from "./fankui.vue?vue&type=script&lang=js"
export * from "./fankui.vue?vue&type=script&lang=js"
import style0 from "./fankui.vue?vue&type=style&index=0&id=8c52b1ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c52b1ee",
  null
  
)

export default component.exports